import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Send, DollarSign, TrendingUp, Star, CheckCircle, XCircle, Clock } from 'lucide-react';

const API_URL = '/api';

function Dashboard() {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    fetchAnalytics();
  }, [selectedDate]);

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/dashboard/analytics`, {
        params: { date: selectedDate }
      });
      setAnalytics(response.data);
    } catch (error) {
      console.error('Error fetching analytics:', error);
      alert('Gagal memuat data analytics');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!analytics) {
    return <div className="error">Gagal memuat data</div>;
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR'
    }).format(value);
  };

  return (
    <div className="dashboard">
      <div className="page-header">
        <h1>Dashboard</h1>
        <input
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="date-picker"
        />
      </div>

      {/* Row 1: 4 Columns */}
      <div className="stats-grid-4">
        <div className="stat-card">
          <div className="stat-icon blue">
            <Send size={24} />
          </div>
          <div className="stat-info">
            <p className="stat-label">Total Blast Hari Ini</p>
            <p className="stat-value">{analytics.daily.total_blast}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon green">
            <DollarSign size={24} />
          </div>
          <div className="stat-info">
            <p className="stat-label">Total Deposit</p>
            <p className="stat-value">{analytics.daily.total_deposit}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon purple">
            <TrendingUp size={24} />
          </div>
          <div className="stat-info">
            <p className="stat-label">Nominal Deposit</p>
            <p className="stat-value">{formatCurrency(analytics.daily.nominal_deposit)}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon orange">
            <Star size={24} />
          </div>
          <div className="stat-info">
            <p className="stat-label">Total Point</p>
            <p className="stat-value">{analytics.daily.total_points}</p>
          </div>
        </div>
      </div>

      {/* Row 2: 3 Columns */}
      <div className="stats-grid mt-20">
        <div className="stat-card">
          <div className="stat-icon success">
            <CheckCircle size={24} />
          </div>
          <div className="stat-info">
            <p className="stat-label">Nomor Valid</p>
            <p className="stat-value">{analytics.uploads.total_valid}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon danger">
            <XCircle size={24} />
          </div>
          <div className="stat-info">
            <p className="stat-label">Nomor Invalid</p>
            <p className="stat-value">{analytics.uploads.total_invalid}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon warning">
            <Clock size={24} />
          </div>
          <div className="stat-info">
            <p className="stat-label">Belum Dicek</p>
            <p className="stat-value">{analytics.uploads.total_unchecked}</p>
          </div>
        </div>
      </div>

      <div className="chart-container">
        <h2>Trend Deposit (7 Hari Terakhir)</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={analytics.trend}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="tanggal" />
            <YAxis />
            <Tooltip
              formatter={(value, name) => {
                if (name === 'total_nominal') {
                  return formatCurrency(value);
                }
                return value;
              }}
            />
            <Legend />
            <Bar dataKey="jumlah_deposit" fill="#8884d8" name="Jumlah Deposit" />
            <Bar dataKey="total_nominal" fill="#82ca9d" name="Total Nominal" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default Dashboard;